'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.object.to-string.js
// module id = 460
// module chunks = 168707334958949